import {ANTIBODY_INTERFACE_ICON_MAPPING} from 'antibodies/schema-configuration/AntibodyInterfaceIconMapping';
import {DomainGraphType} from 'app-core/framework/CoreObjectConstants';
import {isCoreObject} from 'app-core/framework/CoreObjectIntrospectionUtils';
import {EQUIPMENT_SCHEMA_INTERFACE_ID, EQUIPMENT_ICON} from 'instruments/equipment/EquipmentConstants';
import {COMPLEX_POLYMER_SCHEMA_INTERFACE_ICON_MAPPING} from 'modbio/complex-polymers/ComplexPolymerSchemaInterfaceConstants';
import {
  TRIAL_SUBJECT_SCHEMA_INTERFACE_ID,
  TRIAL_SAMPLE_SCHEMA_INTERFACE_ID,
  TRIAL_SUBJECT_ICON,
  TRIAL_SAMPLE_ICON,
} from 'registry/trial-interfaces/TrialInterfaceConstants';
import {
  EXPIRATION_TRACKING_ENTITY_SCHEMA_INTERFACE_ID,
  EXPIRATION_TRACKING_ICON,
} from 'samples/valid-contents/ValidContentsConstants';
import {
  SchemaInterfaceSummary,
  StaticSchemaInterfaceSummary,
} from 'schemas/schema-interface/SchemaInterfaceConstants';
import getSchemaInterfaceType from 'schemas/schema-interface/v2/getSchemaInterfaceType';
import {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';

export type IconMapping = Record<StaticSchemaInterfaceSummary['id'], BenchlingIconName>;

const iconMappings: Array<IconMapping> = [
  ANTIBODY_INTERFACE_ICON_MAPPING,
  COMPLEX_POLYMER_SCHEMA_INTERFACE_ICON_MAPPING,
  {
    [EQUIPMENT_SCHEMA_INTERFACE_ID]: EQUIPMENT_ICON,
  },
  {
    [EXPIRATION_TRACKING_ENTITY_SCHEMA_INTERFACE_ID]: EXPIRATION_TRACKING_ICON,
  },
  {
    [TRIAL_SUBJECT_SCHEMA_INTERFACE_ID]: TRIAL_SUBJECT_ICON,
  },
  {
    [TRIAL_SAMPLE_SCHEMA_INTERFACE_ID]: TRIAL_SAMPLE_ICON,
  },
];

function isStaticSchemaInterfaceId(
  schemaInterfaceId: string
): schemaInterfaceId is StaticSchemaInterfaceSummary['id'] {
  if (!isCoreObject({id: schemaInterfaceId})) {
    return false;
  }
  return getSchemaInterfaceType(schemaInterfaceId) === DomainGraphType.STATIC_SCHEMA_INTERFACE;
}

export default function getSchemaInterfaceIcon(
  schemaInterfaceId: SchemaInterfaceSummary['id'] | StaticSchemaInterfaceSummary['id']
): BenchlingIconName {
  if (isStaticSchemaInterfaceId(schemaInterfaceId)) {
    const relevantIconMapping = iconMappings.find((mapping) => mapping.hasOwnProperty(schemaInterfaceId));
    if (relevantIconMapping != null) {
      return relevantIconMapping[schemaInterfaceId];
    }
  }
  return 'object-intersect';
}
